import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { getPromoReadingMs } from '../../lib/promoBanner';

const PromoBanner = ({ lines, onClose, closeLabel }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [lines]);

  useEffect(() => {
    if (lines.length <= 1) return undefined;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = getPromoReadingMs(lines[activeIndex], reducedMotion);

    const timer = window.setTimeout(() => {
      setActiveIndex((current) => (current + 1) % lines.length);
    }, duration);

    return () => window.clearTimeout(timer);
  }, [lines, activeIndex]);

  if (!lines.length) return null;

  const activeLine = lines[activeIndex];

  return (
    <div className="relative bg-[#1a1a2e] px-4 py-2 pr-10 text-center text-xs text-white sm:text-sm">
      <div className="promo-banner-viewport mx-auto max-w-4xl" aria-live="polite">
        <span key={`${activeIndex}-${activeLine}`} className="promo-banner-line">
          {activeLine}
        </span>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="absolute right-4 top-1/2 -translate-y-1/2 hover:opacity-70 transition-opacity"
        aria-label={closeLabel}
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default PromoBanner;
